<template>
  <div class="refusePage">
    <div class="block">
      <h1>拍照：</h1>
      <div class="upload_wrap flex-between">
        <div class="upload_item flex-rowc">
          <i class="iconfont icon-paizhao"></i>
        </div>
        <div class="upload_item flex-rowc">
          <i class="iconfont icon-paizhao"></i>
        </div>
        <div class="upload_item flex-rowc">
          <i class="iconfont icon-paizhao"></i>
        </div>
      </div>
    </div>
    <div class="block">
      <h1>暂停原因：</h1>
      <div class="select_wrap">
        <div class="select_item flex-rowl">
          <i class="iconfont icon-yuanquangouxuan"></i> 商品包装破损
        </div>
        <div class="select_item flex-rowl">
          <i class="iconfont icon-yuanquangouxuan"></i> 实际商品与订单内容不符
        </div>
        <div class="select_item flex-rowl">
          <i class="iconfont icon-yuanquangouxuan"></i>
          <van-field v-model="value" placeholder="其他原因" />
        </div>
      </div>
    </div>

    <div class="btn_group flex-colc">
      <div class="primary-button">确认提交</div>
      <div class="return_txt" @click="handleReturn">←取消返回</div>
    </div>
  </div>
</template>
  
<script>
import { getToken } from "../../api/api";
export default {
  name: "tMealRefuse",
  data() {
    return {
      userInfo: "", // 用户信息
      order_id: "", // 订单id
      token: "", // token

      value: "",
    };
  },
  created() {
    let { id } = this.$route.params;
    this.order_id = id;
    this.token = this.$store.state.Authorization;
    this.userInfo = this.$store.state.USERINFO;
    this.getToken();
  },
  methods: {
    // 获取token
    getToken() {
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);

          //   if (isSubmit) {
          //     this.getTakeMeal(res.data.token);
          //   } else {
          //     this.getOrderInfo(res.data.token);
          //   }
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.refusePage {
  padding-top: 80px;
  .block {
    padding: 0 45px;
    margin-bottom: 128px;
    box-sizing: border-box;
    h1 {
      font-size: 36px;
      color: #040000;
      font-weight: bold;
      padding-left: 44px;
    }
    .upload_wrap {
      margin-top: 100px;
      .upload_item {
        width: 200px;
        height: 200px;
        background: #dcdcdc;
        .iconfont {
          font-size: 80px;
          color: #7e7e7e;
        }
      }
    }
    .select_wrap {
      margin-top: 19px;
      .select_item {
        font-size: 28px;
        color: #040000;
        width: 100%;
        height: 100px;
        background: #fff;
        border: 1px solid #e6e6e6;
        padding: 0 30px;
        box-sizing: border-box;
        .iconfont {
          margin-right: 20px;
          color: #515151;
          font-size: 40px;
        }
        &:nth-child(2) {
          margin: 20px 0;
        }
        .van-cell {
          padding: 0;
        }
      }
    }
  }
  .btn_group {
    font-size: 24px;
    color: #333333;
    .primary-button {
      width: 300px;
      height: 90px;
      line-height: 90px;
      margin-bottom: 90px;
    }
  }
}
</style>